import { useRef, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import TopBar from "./TopBar";
import { useStateDistrict, useConsignmentTypes, useShippingModes } from "../../utils/Utilities.js";
const CREATE_FRANCHISE_RATE_URL = "/api/admin/create-franchise-rate";


const CreateFranchiseRate = () => {

    const [showValidation, setShowValidation] = useState(false);
    const {
        statesList,
        districtsList,
        stateId,
        setStateId,
        district,
        setDistrict,
        loadingStates,
        loadingDistricts,
    } = useStateDistrict();


    const back = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setFranchiseName("");
    };

    const axiosPrivate = useAxiosPrivate();
    const userRef = useRef();
    const errRef = useRef();
    const { auth } = useAuth();


    // const [role, setRole] = useState("");
    const [franchiseName, setFranchiseName] = useState("");

    const [errMsg, setErrMsg] = useState("");
    const [success, setSuccess] = useState(false);

    const [selectedFranchise, setSelectedFranchise] = useState(null);
    const [franchiseDbId, setFranchiseDbId] = useState('');
    const [franchiseList, setFranchiseList] = useState([]);
    const [filteredFranchises, setFilteredFranchises] = useState([]);

    const LIST_FRANCHISE_URL = "api/list-franchises";
    const [loading, setLoading] = useState(false);


    // Handle selection from dropdown
    const handleSelect = (franchise) => {
        setFranchiseName(franchise.franchise_name);
        setFranchiseDbId(franchise.franchise_id);
        setSelectedFranchise(franchise);
        setFilteredFranchises([]);
    };

    const debounceRef = useRef(null);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setFranchiseName(value);

        // Clear dropdown if input is empty
        if (!value.trim()) {
            setFilteredFranchises([]);
            return;
        }

        // Debounce API call
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            fetchFranchises(value);
        }, 400);
    };


    const fetchFranchises = async (searchValue) => {
        try {
            setLoading(true);

            const response = await axiosPrivate.get(
                `api/list-franchises`,
                {
                    params: {
                        // franchise_name: searchValue,
                        // franchise_code: searchValue,
                        search_text: searchValue
                    },
                }
            );

            setFilteredFranchises(response.data || []);
        } catch (error) {
            console.error("Error fetching franchises", error);
            setFilteredFranchises([]);
        } finally {
            setLoading(false);
        }
    };


    const [consignmentType, setConsignmentType] = useState("");
    const [shippingMode, setShippingMode] = useState("");


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                franchise_id: Number(franchiseDbId),
                shipping_mode: shippingMode,
                consignment_type: consignmentType,
                min_weight: Number(minimumWeight),
                max_weight: Number(maximumWeight),
                rate: Number(rate),
                ab_cost: Number(ab_cost),
                surcharge_perc: Number(surchargePerc),
                state_id: Number(stateId)
            };

            // Optional fields
            const optionalFields = {
                district_id: district,
            };

            Object.entries(optionalFields).forEach(([key, value]) => {
                if (value !== "" && value !== null && value !== undefined) {
                    payload[key] = Number.isNaN(Number(value)) ? value : Number(value);
                }
            });

            await axiosPrivate.post(CREATE_FRANCHISE_RATE_URL, payload, {
                headers: { "Content-Type": "application/json" },
                withCredentials: true,
            });

            alert("Franchise rate created successfully");
            ClearSubmitedData();

        } catch (err) {
            let message = "";

            if (!err?.response) {
                message = "No Server Response";
            } else if (err.response?.status === 409) {
                message = err.response?.data.message;
            } else {
                message = "Failed!\n" + err.response?.data.message;
            }

            setErrMsg(message);

            // Clear error message after 5 seconds
            setTimeout(() => {
                setErrMsg("");
            }, 5000);
        }

    };

    const ClearSubmitedData = async (e) => {
        setFranchiseName("");
        setFranchiseDbId("");
        setShippingMode("");
        setConsignmentType("");
        setMinimumWeight("");
        setMaximumWeight("");
        setRate("");
        setAb_cost("");
        setSurchargePerc("");
        setStateId("");
        setDistrict("");

    }




    const { consignmentTypes } = useConsignmentTypes();
    const { shippingModes } = useShippingModes();



    const [minimumWeight, setMinimumWeight] = useState("");
    const [maximumWeight, setMaximumWeight] = useState("");
    const [rate, setRate] = useState("");
    const [ab_cost, setAb_cost] = useState("");
    const [surchargePerc, setSurchargePerc] = useState("");


    const navigate = useNavigate();
    const handleRedirect = () => {
        navigate("/list/franchise_rate");
    }
    return (
        <>
            <Container>

                <section className="userregbody">
                    <p
                        ref={errRef}
                        className={errMsg ? "errmsg" : "offscreen"}
                        aria-live="assertive"

                    >
                        {errMsg}
                    </p>

                    <div className=" wrapper3">
                        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
                        <button type="button" onClick={handleRedirect} className="btn btn-success ms-auto d-block top-bt">Franchise rate list</button>
                        <form onSubmit={handleSubmit}> {/* Add onSubmit handler to trigger login */}

                            <h3>Create franchise rate</h3>
                            <Row>
                                <Col>
                                    <div className="input-boxs">
                                        <label htmlFor="FranchiseName">
                                            Franchise Name or Code <sup>*</sup>
                                        </label>

                                        <input
                                            type="text"
                                            id="franchise-name"
                                            autoComplete="off"
                                            placeholder="Search Franchise Name or Code"
                                            onChange={handleInputChange}
                                            value={franchiseName}
                                            required
                                            style={styles.input}
                                        />

                                        {loading && <div className="loader">Searching...</div>}

                                        {franchiseName && filteredFranchises.length > 0 && (
                                            <ul style={styles.dropdown}>
                                                {filteredFranchises.map((franchise) => (
                                                    <li
                                                        key={franchise.franchise_id}
                                                        style={styles.dropdownItem}
                                                        onMouseDown={() => handleSelect(franchise)}
                                                    >
                                                        {franchise.franchise_name} ({franchise.franchise_code})
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>

                                </Col>
                                <Col>

                                    <div className="input-boxs">
                                        <label>State
                                            <sup>*</sup></label>

                                        <select
                                            className="newregselect"
                                            value={stateId}
                                            onChange={(e) => setStateId(e.target.value)}
                                            required
                                        >
                                            <option value="">Select State</option>

                                            {statesList.map((state) => (
                                                <option key={state.state_id} value={state.state_id}>
                                                    {state.state_name} - ({state.state_code})
                                                </option>
                                            ))}
                                        </select>

                                        {showValidation && !stateId && (
                                            <div className="mt-1 reqstyl">*State is required</div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row>

                                <Col>

                                    <div className="input-boxs">
                                        <label>District</label>

                                        <select
                                            className="newregselect"
                                            value={district}
                                            onChange={(e) => setDistrict(e.target.value)}
                                            disabled={!stateId}
                                        >
                                            <option value="">Select District</option>

                                            {districtsList.map((dist) => (
                                                <option key={dist.district_id} value={dist.district_id}>
                                                    {dist.district_name} - ({dist.district_code})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="Username">Shipping Mode
                                            <sup>*</sup></label>
                                        <select
                                            className="form-control newregselect"
                                            value={shippingMode}
                                            onChange={(e) => setShippingMode(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Shipping Mode</option>

                                            {shippingModes.map((mode) => (
                                                <option key={mode.shipping_mode} value={mode.shipping_mode}>
                                                    {mode.description}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>

                                    <div className=" input-boxs">
                                        <label htmlFor="password">Consignment Type
                                            <sup>*</sup></label>
                                        <select
                                            className="form-control newregselect"
                                            value={consignmentType}
                                            onChange={(e) => setConsignmentType(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Consignment Type</option>

                                            {consignmentTypes.map((item) => (
                                                <option
                                                    key={item.consignment_type}
                                                    value={item.consignment_type}
                                                >
                                                    {item.description}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                                {/* <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="confirm_pwd">Minimum Weight
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="minimumWeight"
                                            value={minimumWeight}
                                            min="0"
                                            step="1"
                                            onChange={(e) => setMinimumWeight(e.target.value)}
                                            required
                                        // placeholder="Minimum Weight"
                                        />

                                    </div>
                                </Col> */}

                                <Col>

                                    <div className="input-boxs">
                                        <label htmlFor="confirm_pwd">
                                            Maximum Weight
                                            <sup>*</sup>
                                        </label>

                                        <div className="weight-input-wrapper">
                                            <input
                                                type="number"
                                                name="maximumWeight"
                                                value={maximumWeight}
                                                min="0"
                                                step="0.001"
                                                onChange={(e) => setMaximumWeight(e.target.value)}
                                                required
                                            />
                                            <span>kg</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className=" input-boxs">
                                        <label>Rate
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="rate"
                                            value={rate}
                                            min="0"
                                            step="1"
                                            onChange={(e) => setRate(e.target.value)}
                                            required
                                        />
                                    </div>
                                </Col>

                                <Col>
                                    <div className=" input-boxs">
                                        <label >ab cost
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="ab_cost"
                                            value={ab_cost}
                                            min="0"
                                            step="1"
                                            onChange={(e) => setAb_cost(e.target.value)}
                                            required
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className=" input-boxs">
                                        <label >Surcharge %
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="surchargePerc"
                                            value={surchargePerc}
                                            min="0"
                                            step="1"
                                            onChange={(e) => setSurchargePerc(e.target.value)}
                                            required
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <center>
                                <button type="submit" className="btn regbutton">Submit</button>
                            </center>
                        </form>
                    </div>
                </section>

                <TopBar />
            </Container>
        </>
    );
};

const styles = {
    container: {
        padding: '40px',
        maxWidth: '500px',
        margin: 'auto',
        fontFamily: 'Arial, sans-serif',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    inputWrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    input: {
        padding: '10px',
        fontSize: '16px',
        border: '1px solid #ccc',
        borderRadius: '4px',
    },
    dropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderTop: 'none',
        maxHeight: '200px',
        overflowY: 'auto',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee',
    },
    button: {
        padding: '10px 15px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        cursor: 'pointer',
    },


};

export default CreateFranchiseRate;
